import { useAuth } from './useAuth';

export interface UserPermissions {
  canViewAllTenants: boolean;
  canManageSystem: boolean;
  canCreateDocuments: boolean;
  canViewOwnData: boolean;
  canManageUsers: boolean;
  canUploadCertificates: boolean;
  canViewSystemStats: boolean;
  tenantId: string | null;
  userRole: string;
}

export const usePermissions = (): UserPermissions => {
  const { user } = useAuth();

  if (!user) {
    return {
      canViewAllTenants: false,
      canManageSystem: false,
      canCreateDocuments: false,
      canViewOwnData: false,
      canManageUsers: false,
      canUploadCertificates: false,
      canViewSystemStats: false,
      tenantId: null,
      userRole: 'guest'
    };
  }

  const isSuperAdmin = user.role === 'super_admin';
  const isAdmin = user.role === 'admin';
  const isTenantUser = user.role === 'tenant_user';
  const isApiClient = user.role === 'api_client';

  return {
    canViewAllTenants: isSuperAdmin || isAdmin,
    canManageSystem: isSuperAdmin,
    canCreateDocuments: isSuperAdmin || isAdmin || isTenantUser,
    canViewOwnData: true,
    canManageUsers: isSuperAdmin || isAdmin,
    canUploadCertificates: isSuperAdmin || isAdmin || isTenantUser,
    canViewSystemStats: isSuperAdmin || isAdmin,
    tenantId: user.tenant_id,
    userRole: user.role
  };
};

export default usePermissions;